enum ImportCSVUploadingErrors {
  WRONG_COLUMN_TYPE = 'wrong_column_type',
  NO_INTERNET_CONNECTION = 'no_internet_connection',
  COMMON = 'common',
  CANCELED = 'canceled',
}

export default ImportCSVUploadingErrors;
